import React, { useEffect, useState } from "react";
import DashboardMUI from "../dashboard/DashboardMui";
import VideoFrame from "../videoconference/VideoFrame";
import { useLocation } from "react-router-dom";
import VideoConferenceIcon from "../../images/videoconference.svg";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import PrenscriptionDialog from "../prescription/PrenscriptionDialog";
import Axios from "axios";
import useUserState from "../hooks/useUserState";
import TabsContainer from "../prescription/TabsContainer";
import EHRaccordion from "./EHRaccordion";
import useBDocTranslator from "../hooks/useBDocTranslator";
import PrescriptionEHR from "../prescription/PrescriptionEHR";

export default function LobbyProvider(props) {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState(""); // this is the state for prescription
  const [responseMessage, setResponseMessage] = useState("");
  const [responseCNMessage, setResponseCNMessage] = useState("");

  const [enabledSave, setEnabledSave] = useState(true);
  // Consultation Notes
  const [consultationNotes, setConsultationNotes] = useState("");

  const { event_code, providerFullname, password, appointmentId, patientId } =
    location.state;

  const { t } = useBDocTranslator();

  const handleNotes = (value) => {
    setNotes(value);
  };

  const [prescType, setPrescType] = useState();

  const [refreshData, setRefreshData] = useState(false);

  return (
    <DashboardMUI
      sectionTitle={t("Online Consultation")}
      description={t(
        "Please Allow the use of Camera and Microphone on your Browser"
      )}
      icon={VideoConferenceIcon}
    >
      <div className="row">
        <div className="video-container col-md-8 col-sm-12">
          <VideoFrame
            eventCode={event_code}
            displayName={providerFullname}
            // password={password}
          />
        </div>
        <div className="col-md-4 col-sm-12">
          <EHRaccordion
            handleNotes={handleNotes}
            responseMessage={responseMessage}
            responseCNMessage={responseCNMessage}
            enabledSaveBtn={enabledSave}
            consultationNotesValue={consultationNotes}
            patientId={patientId}
            prescType={prescType}
            setPrescType={setPrescType}
            handleRefreshData={() => setRefreshData(!refreshData)}
            appointmentId={appointmentId}
          />
        </div>
      </div>
    </DashboardMUI>
  );
}
